// extracted by mini-css-extract-plugin
export default {"root":"_2hgZm","large":"_3HnTx","medium":"_4glb0","small":"_3OPjT","daily-deviation":"_3CHfJ","dailyDeviation":"_3CHfJ","hype":"_2-jmu","stash":"_3UEMA"};